const LOG_ACTIONS = {
  EXPORTED: "EXPORTED",
  EDITED: "EDITED",
  CREATED: "CREATED",
};

export default LOG_ACTIONS;
